<template>
  <div class="profit-page">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="container">
        <div class="logo">知予 AI</div>
        <nav class="nav-links">
          <router-link to="/">首页</router-link>
          <router-link to="/profit" class="active">盈利模式</router-link>
          <router-link to="/services">产品服务</router-link>
          <router-link to="/blog">心理科普</router-link>
          <router-link to="/about">关于我们</router-link>
        </nav>
        <div class="navbar-actions">
          <button class="btn-primary" @click="goToHome">立即体验</button>
        </div>
      </div>
    </header>

    <!-- 英雄区 -->
    <section class="profit-hero">
      <div class="container">
        <h1 class="hero-title">盈利模式</h1>
        <p class="hero-desc">为心理机构和个人咨询师提供多元化的盈利方案</p>
      </div>
    </section>

    <!-- 入驻优势 -->
    <section class="advantage-section">
      <div class="container">
        <h2 class="section-title">入驻优势</h2>
        <p class="section-desc">加入知予 AI 平台，享受全方位的资源支持和技术赋能</p>
        <div class="advantage-grid">
          <div class="advantage-card">
            <div class="advantage-icon">
              <i class="el-icon-s-marketing"></i>
            </div>
            <h3 class="advantage-title">平台资源</h3>
            <p class="advantage-desc">接入平台庞大的用户流量，获得更多潜在客户</p>
            <ul class="advantage-list">
              <li>• 平台用户突破100万</li>
              <li>• 精准的用户匹配</li>
              <li>• 多渠道推广支持</li>
            </ul>
          </div>
          <div class="advantage-card">
            <div class="advantage-icon">
              <i class="el-icon-s-custom"></i>
            </div>
            <h3 class="advantage-title">流量支持</h3>
            <p class="advantage-desc">平台提供持续的流量支持，帮助你快速获得客户</p>
            <ul class="advantage-list">
              <li>• 搜索引擎优化</li>
              <li>• 社交媒体推广</li>
              <li>• 线下活动合作</li>
            </ul>
          </div>
          <div class="advantage-card">
            <div class="advantage-icon">
              <i class="el-icon-s-finance"></i>
            </div>
            <h3 class="advantage-title">技术赋能</h3>
            <p class="advantage-desc">借助AI技术，提升服务质量和效率，降低运营成本</p>
            <ul class="advantage-list">
              <li>• AI助手支持</li>
              <li>• 智能客户管理</li>
              <li>• 数据分析工具</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- 合作模式 -->
    <section class="cooperation-section">
      <div class="container">
        <h2 class="section-title">合作模式</h2>
        <p class="section-desc">多种合作模式，满足不同机构和咨询师的需求</p>
        <div class="cooperation-grid">
          <div class="cooperation-card">
            <h3 class="cooperation-title">个人咨询师</h3>
            <p class="cooperation-desc">适合独立执业的心理咨询师</p>
            <ul class="cooperation-list">
              <li>
                <i class="el-icon-check"></i>
                <span>平台提供AI助手，帮助处理日常咨询工作</span>
              </li>
              <li>
                <i class="el-icon-check"></i>
                <span>接入平台流量，获得更多咨询机会</span>
              </li>
              <li>
                <i class="el-icon-check"></i>
                <span>灵活的定价策略，自主设置服务价格</span>
              </li>
              <li>
                <i class="el-icon-check"></i>
                <span>平台收取少量服务费，收益大部分归咨询师</span>
              </li>
            </ul>
          </div>
          <div class="cooperation-card">
            <h3 class="cooperation-title">心理机构</h3>
            <p class="cooperation-desc">适合中小型心理机构</p>
            <ul class="cooperation-list">
              <li>
                <i class="el-icon-check"></i>
                <span>整体入驻平台，展示机构品牌和服务</span>
              </li>
              <li>
                <i class="el-icon-check"></i>
                <span>管理多个咨询师账号，统一后台管理</span>
              </li>
              <li>
                <i class="el-icon-check"></i>
                <span>平台提供品牌推广支持，提升机构知名度</span>
              </li>
              <li>
                <i class="el-icon-check"></i>
                <span>享受更优惠的平台服务费率</span>
              </li>
            </ul>
          </div>
          <div class="cooperation-card">
            <h3 class="cooperation-title">企业合作</h3>
            <p class="cooperation-desc">适合提供企业EAP服务的机构</p>
            <ul class="cooperation-list">
              <li>
                <i class="el-icon-check"></i>
                <span>接入企业EAP服务平台，获得企业客户</span>
              </li>
              <li>
                <i class="el-icon-check"></i>
                <span>提供企业员工心理健康评估和干预服务</span>
              </li>
              <li>
                <i class="el-icon-check"></i>
                <span>平台提供企业客户资源，拓展业务范围</span>
              </li>
              <li>
                <i class="el-icon-check"></i>
                <span>定制化的企业服务方案</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>


    <!-- 扶持政策 -->
    <section class="support-section">
      <div class="container">
        <h2 class="section-title">扶持政策</h2>
        <p class="section-desc">平台提供全方位的扶持政策，帮助合作方快速成长</p>
        <div class="support-grid">
          <div class="support-card">
            <div class="support-icon">
              <i class="el-icon-s-flag"></i>
            </div>
            <h3 class="support-title">培训支持</h3>
            <p class="support-desc">提供专业的培训课程，提升咨询师的专业能力和服务水平</p>
            <ul class="support-list">
              <li>• 专业技能培训</li>
              <li>• 平台操作培训</li>
              <li>• 营销策略培训</li>
            </ul>
          </div>
          <div class="support-card">
            <div class="support-icon">
              <i class="el-icon-s-marketing"></i>
            </div>
            <h3 class="support-title">市场推广</h3>
            <p class="support-desc">平台提供多渠道的市场推广支持，提升合作方的知名度</p>
            <ul class="support-list">
              <li>• 平台首页推荐</li>
              <li>• 社交媒体推广</li>
              <li>• 线下活动合作</li>
            </ul>
          </div>
          <div class="support-card">
            <div class="support-icon">
              <i class="el-icon-s-finance"></i>
            </div>
            <h3 class="support-title">收益保障</h3>
            <p class="support-desc">平台提供收益保障机制，确保合作方的稳定收益</p>
            <ul class="support-list">
              <li>• 透明的收益结算</li>
              <li>• 优惠的服务费率</li>
              <li>• 收益增长激励</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- 合作申请 -->
    <section class="application-section">
      <div class="container">
        <h2 class="section-title">合作申请</h2>
        <p class="section-desc">立即加入知予 AI 平台，开启你的心理健康服务盈利之旅</p>
        <div class="application-content">
          <div class="application-form">
            <el-form :model="form" :rules="rules" ref="form" label-width="100px">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item label="电话" prop="phone">
                <el-input v-model="form.phone"></el-input>
              </el-form-item>
              <el-form-item label="公司名称" prop="company">
                <el-input v-model="form.company"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm" :loading="loading">提交申请</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="application-info">
            <h3 class="application-subtitle">联系我们</h3>
            <p class="application-item">
              <i class="el-icon-phone"></i>
              <span>联系电话：13100987983</span>
            </p>
            <p class="application-item">
              <i class="el-icon-position"></i>
              <span>微信号：yxxgx9</span>
            </p>
            <p class="application-item" style="align-items: flex-start;">
              <i class="el-icon-picture-outline"></i>
              <span><img src="https://h5smapp.dayujh.cn/upload/sys/image/69/9151955851f6033c3ac85bbdbea9a2.jpg" alt="微信二维码"
                    style="width: 220px;height: 300px;"></span>
            </p>
            <div class="application-benefits">
              <h4>加入我们，你将获得：</h4>
              <ul>
                <li>• 稳定的客户来源</li>
                <li>• 专业的技术支持</li>
                <li>• 丰厚的收益回报</li>
                <li>• 持续的成长机会</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'Profit',
  data() {
    return {
      form: {
        name: '',
        phone: '',
        company: '',
        cooperationType: '个人咨询师'
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
        company: [
          { required: false, message: '请输入公司名称', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    goToHome() {
      this.$router.push('/');
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          // 调用接口提交表单
          fetch('https://aixinli.dayujh.cn/admin/contact/submit', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              name: this.form.name,
              phone: this.form.phone,
              company: this.form.company
            })
          })
          .then(response => response.json())
          .then(data => {
            this.loading = false;
            if (data.code === 200) {
              this.$message.success(data.msg);
              this.$refs.form.resetFields();
            } else {
              this.$message.error('提交失败，请稍后重试');
            }
          })
          .catch(error => {
            this.loading = false;
            this.$message.error('网络错误，请稍后重试');
          });
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
.profit-page {
  min-height: 100vh;
}

/* 导航栏 */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 15px 0;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  font-size: 24px;
  font-weight: bold;
  color: #9c89b8;
}

.nav-links {
  display: flex;
  gap: 20px;
}

.nav-links a {
  color: #333;
  text-decoration: none;
  font-size: 16px;
  transition: color 0.3s ease;
}

.nav-links a:hover {
  color: #9c89b8;
}

.nav-links .active {
  color: #9c89b8;
  font-weight: bold;
}

.navbar-actions {
  display: flex;
  gap: 10px;
}

.btn-primary {
  background: linear-gradient(135deg, #9c89b8, #b8bedd);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 25px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(156, 137, 184, 0.3);
}

/* 英雄区 */
.profit-hero {
  padding: 120px 0 80px;
  background: linear-gradient(135deg, #f5f7fa, #e9ecef);
  text-align: center;
}

.hero-title {
  font-size: 48px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.hero-desc {
  font-size: 24px;
  color: #666;
  margin-bottom: 40px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

/* 通用区块样式 */
.section-title {
  font-size: 36px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

.section-desc {
  font-size: 18px;
  color: #666;
  text-align: center;
  margin-bottom: 60px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 入驻优势 */
.advantage-section {
  padding: 80px 0;
  background-color: white;
}

.advantage-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.advantage-card {
  background-color: #f9f9f9;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.advantage-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.advantage-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #9c89b8, #b8bedd);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  color: white;
  font-size: 24px;
}

.advantage-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
}

.advantage-desc {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
  line-height: 1.6;
}

.advantage-list {
  list-style: none;
}

.advantage-list li {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
  line-height: 1.4;
}

/* 合作模式 */
.cooperation-section {
  padding: 80px 0;
  background: linear-gradient(135deg, #f5f7fa, #e9ecef);
}

.cooperation-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.cooperation-card {
  background-color: white;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.cooperation-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.cooperation-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
}

.cooperation-desc {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
  line-height: 1.6;
}

.cooperation-list {
  list-style: none;
}

.cooperation-list li {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  margin-bottom: 15px;
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

.cooperation-list li i {
  color: #9c89b8;
  font-size: 16px;
  margin-top: 2px;
}

/* 全流程 */
.process-section {
  padding: 80px 0;
  background-color: white;
}

.process-steps {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
}

.process-step {
  background-color: #f9f9f9;
  border-radius: 20px;
  padding: 30px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  position: relative;
}

.process-step:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.process-number {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #9c89b8, #b8bedd);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: white;
  font-size: 24px;
  font-weight: bold;
}

.process-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
}

.process-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

/* 扶持政策 */
.support-section {
  padding: 80px 0;
  background: linear-gradient(135deg, #f5f7fa, #e9ecef);
}

.support-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.support-card {
  background-color: white;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.support-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.support-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #9c89b8, #b8bedd);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  color: white;
  font-size: 24px;
}

.support-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
}

.support-desc {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
  line-height: 1.6;
}

.support-list {
  list-style: none;
}

.support-list li {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
  line-height: 1.4;
}

/* 合作申请 */
.application-section {
  padding: 80px 0;
  background-color: white;
}

.application-content {
  display: flex;
  gap: 60px;
  flex-wrap: wrap;
}

.application-form {
  flex: 1;
  min-width: 300px;
  background-color: #f9f9f9;
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.application-info {
  flex: 1;
  min-width: 300px;
}

.application-subtitle {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.application-item {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  font-size: 16px;
  color: #666;
}

.application-item i {
  color: #9c89b8;
  font-size: 20px;
}

.application-benefits {
  margin-top: 40px;
  background-color: #f9f9f9;
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.application-benefits h4 {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.application-benefits ul {
  list-style: none;
}

.application-benefits li {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
  line-height: 1.4;
}

/* 页脚 */
.footer {
  background-color: #333;
  color: white;
  padding: 60px 0 30px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
}

.footer-logo h3 {
  font-size: 24px;
  margin-bottom: 10px;
  color: #9c89b8;
}

.footer-logo p {
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 20px;
}

.footer-links h4 {
  font-size: 18px;
  margin-bottom: 20px;
  color: white;
}

.footer-links ul {
  list-style: none;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: #9c89b8;
}

.footer-contact h4 {
  font-size: 18px;
  margin-bottom: 20px;
  color: white;
}

.footer-contact p {
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 10px;
}

.footer-copyright {
  text-align: center;
  padding-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.footer-copyright p {
  margin-bottom: 5px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .navbar .container {
    flex-direction: column;
    gap: 10px;
  }
  
  .nav-links {
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .hero-title {
    font-size: 36px;
  }
  
  .application-content {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 28px;
  }
  
  .section-title {
    font-size: 28px;
  }
  
  .advantage-grid,
  .cooperation-grid,
  .process-steps,
  .support-grid {
    grid-template-columns: 1fr;
  }
}
</style>